export const BREAKPOINTS = {
  MOBILE: '768px',
  SIDEBAR_WIDTH: '300px',
  SIDEBAR_COLLAPSED_WIDTH: '88px',
} as const;

// Media query helpers for use in styled-components
export const MEDIA = {
  MOBILE: `@media (max-width: ${BREAKPOINTS.MOBILE})`,
} as const;
